import { Trans } from 'react-i18next'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import { IActionFormProps, isValidUrl } from '@makyoapp/makyo-common'
import { Button, ButtonVariant, Field, Label } from '@makyoapp/makyo-ui'

import { parseSingleCellValue } from '@/core/app-builder/parser/single-cell'
import { useForm } from '@/lib/use-form'
import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { ActionInputV3 } from '@/components/ActionInputV3/ActionInputV3'

/**
 * @todo replace `getRowValueIfExist`
 */
export default function ActFormOpenLink({ onSubmit, onDismiss, initialData }: IActionFormProps) {
  const { dbClient } = useDbClientContext()
  const { activeLayerDetailRowIndex } = useActiveLayerContext()

  const { form, onSubmit: onFormSubmit } = useForm({
    defaultValues: {
      value: initialData?.value || {},
    },
    async validate(data, setError) {
      let isManualInput = !data.value.tableId && !data.value.dataType
      let value =
        (await parseSingleCellValue(
          { col: data.value.value, tbl: data.value.tableId, row: activeLayerDetailRowIndex },
          dbClient
        )) ?? data.value.value

      let isEmpty = !value?.trim().length
      let errMessage = isEmpty ? 'URL cannot be empty' : isManualInput && !isValidUrl(value) ? 'Invalid file URL' : null

      setError('value', errMessage)
    },
    validateMode: 'onSubmit',
  })

  const handleSubmit = onFormSubmit((data) => {
    onSubmit(data)
  })

  const value = form.getValues('value')
  const invalidForm = !value?.value?.trim().length || !!form.errors

  return (
    <div>
      <div className='p-4'>
        <Field>
          <Label required>URL</Label>

          <ActionInputV3
            options={initialData?.actionOptions}
            isActionWorkflow={initialData?.isActionWorkflow}
            value={form.getValues('value')}
            columnTypes={[ColumnTypes.URL, ColumnTypes.Image, ColumnTypes.Attachment]}
            columnDataTypes={['profile', 'single-cell']}
            onChange={({ ...value }) => {
              form.setValues('value', value)
            }}
            error={form.errors?.value}
          />
        </Field>
      </div>

      <div className='px-4 py-2 border-t bdr flex justify-between items-center'>
        <Button variant={ButtonVariant.Outlined} onClick={onDismiss}>
          <Trans>Cancel</Trans>
        </Button>
        <Button onClick={handleSubmit} disabled={invalidForm || form.isValidating}>
          {form.isValidating ? <Trans>Loading...</Trans> : <Trans>Save</Trans>}
        </Button>
      </div>
    </div>
  )
}
